<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          分析依頼
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">レポート</a>
          </li>
      </ul>
    </div>
    <b-card>
      <b-row>
        <b-col>
          ファイルのアップロード
        </b-col>
      </b-row>
      <hr>
      <b-col md="12" style="text-align:center;font-size:15pt;">
        <label class="btn btn-xs btn-info" style="width:90%;height:45px;">
          <b-row>
            <b-form-file v-model="file" @change="bs_file" v-show="false"></b-form-file>
          </b-row>
          ファイルを選択
        </label>
      </b-col>
      <hr>
      <b-row>
        <b-col md="12" class="text-center">
          不審なWebシェルファイルや、Webシェルファイルを報告することができます。 <br>
          疑いのあるファイルの場合、Webシェルが存在するかどうかを判断し、結果をメールで返信します。
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col>
          転送待ち受けリスト
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add" :items="files" :fields="fields">
        <template slot="index" slot-scope="row">{{row.index+1}}</template>
        <template slot="name" slot-scope="row">{{row.item.name}}</template>
        <template slot="description" slot-scope="row">
          <input type="text" placeholder="説明" v-model="file.description" style="width:100%;">
        </template>
        <template slot="size" slot-scope="row">{{row.item.size}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="remove(row.index)" size="sm" variant="outline-danger">削除</b-btn>
          <b-btn @click="send(row.index)" size="sm" variant="outline-primary">送信</b-btn>
        </template>
      </b-table>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
